import { $TSFixMe } from '@f-fertighaus/applications/UserAccount/interfaces/utils'

export const MASSIVHAUS_URLS = {
  houseDetail: (houseSlug: string, vendorSlug: string) =>
    `/baupartner/${vendorSlug}/haeuser/${houseSlug}/` as const,
  vendorDetail: (vendorSlug: string) => `/baupartner/${vendorSlug}/` as const,
  vendorOffices: (vendorSlug: string) =>
    `/baupartner/${vendorSlug}/alle-standorte/` as const,
  vendorOffice: (vendorSlug: string, officeSlug: string) =>
    `/baupartner/${vendorSlug}/standort/${officeSlug}/` as const,
  houseList: () => `/haussuche/` as const,
  vendorList: () => `/baupartner/` as const,
  userAccount: () => `/mein-konto/` as const,
  userProfile: () => `/mein-konto/profil/` as const,
  houseQuiz: () => `/hausbau-quiz/` as const,
  financeQuiz: () => `/baufinanzierung/` as const,
  dataServiceLeadAssignment: () => `data-services/ms-lead-assignment` as const,
  financeAssistance: () => `/finanzierungsanfrage/` as const,
  budgetCalculator: () => `/finanzrechner/` as const,
  pdfGuide: (type: 'property' | 'finance' | 'vendor' | 'consultation') =>
    ({
      finance: `https://neuraum--fertighaus.s3.amazonaws.com/media/public/documents/Checkliste_Baufinanzierung_Massivhaus.de.pdf`,
      property: `https://neuraum--fertighaus.s3.amazonaws.com/media/public/documents/Checkliste_Grundstueckswahl_Massivhaus.de.pdf`,
      vendor: `https://neuraum--fertighaus.s3.amazonaws.com/media/public/documents/Checkliste_Herstellerwahl_Massivhaus.de.pdf`,
      consultation: `https://neuraum--fertighaus.s3.amazonaws.com/media/public/documents/Checkliste-Beratungsgesprach-Massivhaus.de.pdf`
    }[type]),
  vendorMap: () => '/baupartnerkarte/' as const,
  privacyPolicy: () => `/datenschutz/` as const,
  sellerQuiz: (propertyTypeHashParamValue: string) =>
    `/bewertungs-assistent/${propertyTypeHashParamValue}` as const
} as const

export type URLDictionary = keyof typeof MASSIVHAUS_URLS

export function getUrl(key: URLDictionary): $TSFixMe {
  return MASSIVHAUS_URLS[key]
}

if (typeof window !== 'undefined' && window.__DOMAIN__ === 'massivhaus') {
  window.getUrl = getUrl
}
